<template>
    <div class="schedule-summary">
        <template v-for="(location, index) in locations">
            <section v-if="hasAnySchedule(location.value)" :key="index" class="schedule-summary__location">
                <common-divider v-if="!showReversed">
                    <common-icon-info icon="location" size="gigantic">
                        <b>{{ location.label }}</b>
                    </common-icon-info>
                </common-divider>

                <div v-for="(variation, i) in scheduleVariations(location.value)" :key="i" :class="variationsClass">
                    <button
                        v-if="showDiscardButton"
                        type="button"
                        class="schedule-summary__discard"
                        @click="discardSchedule(location.value, variation.days)"
                    >
                        <common-icon name="discard" size="small"></common-icon>

                        <span v-if="!isMobile">{{ $t('forms.auth.schedule.microcopy.discard') }}</span>
                    </button>

                    <div class="schedule-summary__info">
                        <common-icon-info icon="calendar" size="gigantic">
                            <schedule-repeats
                                :frequency="getFrequencyForLocation(location.value)"
                                :startWeekDate="getStartWeekDateForLocation(location.value)"
                                :days="variation.days"
                            ></schedule-repeats>
                        </common-icon-info>
                    </div>

                    <div class="schedule-summary__info">
                        <common-icon-info icon="time" size="gigantic">
                            <common-slots :slots="variation.slots" :hasUnderline="true"></common-slots>
                        </common-icon-info>
                    </div>
                </div>
            </section>
        </template>
    </div>
</template>

<script>
    import { importComponents } from '~/helpers'
    import uniqBy from 'lodash/uniqBy'
    import isEqual from 'lodash.isequal'
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'

    export default {
        mixins: [ScreenSizeDetectionMixin],

        components: {
            ...importComponents(require.context('components/forms/auth-schedule-form'), ['ScheduleSummary']),
        },

        props: {
            locations: { type: Array, required: true },
            schedule: { type: Object, required: true },
            showReversed: { type: Boolean, default: false },
            showDiscardButton: { type: Boolean, default: true },
            isRegistration: { type: Boolean, default: false },
        },

        computed: {
            variationsClass() {
                return {
                    'schedule-summary__variation': true,
                    'schedule-summary__variation--reversed': this.showReversed,
                }
            },
        },

        methods: {
            locationDays(locationId) {
                return this.$get(this.schedule, [locationId, 'days']) || []
            },

            hasAnySchedule(locationId) {
                return this.locationDays(locationId).some((slots) => slots.length > 0)
            },

            scheduleVariations(locationId) {
                return uniqBy(
                    this.locationDays(locationId)
                        .reduce(
                            (variations, slots, day, days) =>
                                variations.concat([
                                    {
                                        days: days
                                            .map((slots, day) => ({ day, slots }))
                                            .filter((day) => isEqual(day.slots, slots))
                                            .map(({ day }) => day),
                                        slots,
                                    },
                                ]),
                            [],
                        )
                        .filter(({ slots }) => slots.length),
                    (variation) => JSON.stringify(variation.slots),
                )
            },

            discardSchedule(locationId, days) {
                this.emitEvent({
                    name: 'discard',
                    payload: { locationId, days },
                })
            },

            getFrequencyForLocation(location) {
                return this.schedule[location].frequency
            },

            getStartWeekDateForLocation(location) {
                return this.isRegistration ? this.schedule[location].startWeekDate : undefined
            },
        },
    }
</script>
